import {
  AlarmIcon,
  ArchiveIcon,
  ArrowArcRightIcon,
  ArrowCounterClockwiseIcon,
  ArrowDownIcon,
  ArrowElbowDownRightIcon,
  ArrowLeftIcon,
  ArrowLineRightIcon,
  ArrowRightIcon,
  ArrowsClockwiseIcon,
  ArrowsCounterClockwiseIcon,
  ArrowsInIcon,
  ArrowsOutIcon,
  ArrowsOutCardinalIcon,
  ArrowsSplitIcon,
  ArrowUpIcon,
  BarricadeIcon,
  BellRingingIcon,
  BookOpenTextIcon,
  BooksIcon,
  BoxArrowDownIcon,
  BriefcaseIcon,
  BroomIcon,
  BuildingOfficeIcon,
  BulldozerIcon,
  CalendarIcon,
  CalendarStarIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  ChatCircleTextIcon,
  ChartBarIcon,
  ChartBarHorizontalIcon,
  ChartLineIcon,
  CheckCircleIcon,
  CheckIcon,
  CheckSquareIcon,
  CircleIcon,
  CityIcon,
  ClipboardTextIcon,
  ClockClockwiseIcon,
  ClockCountdownIcon,
  ClockCounterClockwiseIcon,
  ClockIcon,
  ClockUserIcon,
  CloudMoonIcon,
  ColumnsIcon,
  CompassToolIcon,
  ConfettiIcon,
  CopyIcon,
  CraneTowerIcon,
  DotsNineIcon,
  DotsThreeVerticalIcon,
  DownloadIcon,
  EngineIcon,
  EnvelopeSimpleIcon,
  EyeIcon,
  EyeSlashIcon,
  FactoryIcon,
  FileCsvIcon,
  FileDashedIcon,
  FileIcon,
  FileImageIcon,
  FileMagnifyingGlassIcon,
  FilePdfIcon,
  FileTextIcon,
  FileVideoIcon,
  FileZipIcon,
  FlaskIcon,
  FloppyDiskIcon,
  FunnelIcon,
  GearFineIcon,
  GearIcon,
  GlobeHemisphereWestIcon,
  GlobeIcon,
  GpsFixIcon,
  GraduationCapIcon,
  GridFourIcon,
  HandPalmIcon,
  HeadsetIcon,
  HouseIcon,
  HouseLineIcon,
  IconBase,
  IdentificationCardIcon,
  InfoIcon,
  LifebuoyIcon,
  LightbulbIcon,
  LightningAIcon,
  LightningIcon,
  LinkIcon,
  ListChecksIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  MagnifyingGlassMinusIcon,
  MagnifyingGlassPlusIcon,
  MailboxIcon,
  MapTrifoldIcon,
  MicrophoneIcon,
  MicrophoneSlashIcon,
  MinusIcon,
  MoneyIcon,
  MoonIcon,
  NotebookIcon,
  NutIcon,
  PackageIcon,
  PaperclipIcon,
  PauseIcon,
  PencilSimpleIcon,
  PencilSimpleSlashIcon,
  PipeWrenchIcon,
  PlayCircleIcon,
  PlayIcon,
  PlusIcon,
  ProhibitIcon,
  QrCodeIcon,
  QuestionIcon,
  ReceiptIcon,
  ScalesIcon,
  SealCheckIcon,
  SealQuestionIcon,
  SealWarningIcon,
  ShapesIcon,
  ShareNetworkIcon,
  ShieldPlusIcon,
  SignOutIcon,
  SkullIcon,
  SparkleIcon,
  SquareIcon,
  StackIcon,
  StarIcon,
  StopIcon,
  StorefrontIcon,
  SuitcaseSimpleIcon,
  SunIcon,
  SwapIcon,
  TableIcon,
  TagIcon,
  TextAaIcon,
  TimerIcon,
  TrashIcon,
  TrayArrowDownIcon,
  TrendUpIcon,
  UploadIcon,
  UserCircleCheckIcon,
  UserCircleIcon,
  UserFocusIcon,
  UserGearIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
  WarehouseIcon,
  WarningIcon,
  WarningOctagonIcon,
  WifiHighIcon,
  WifiXIcon,
  WrenchIcon,
  XIcon,
  ArrowClockwiseIcon,
  PrinterIcon,
  CaretUpIcon,
  ListIcon,
  LineVerticalIcon,
  ArrowSquareOutIcon,
  SortAscendingIcon,
  SortDescendingIcon,
  KanbanIcon,
} from "@phosphor-icons/react";

import {
  CounterIcon,
  DeviceIcon,
  DeviceListIcon,
  DeviceModelIcon,
  DeviceModelListIcon,
  FactoryListIcon,
  GanttChartIcon,
  IdentifierIcon,
  ListChecksListIcon,
  NutListIcon,
  PartAssemblyIcon,
  PartDisassemblyIcon,
  PartModelIcon,
  ReceiptListIcon,
  TagAddIcon,
  TagDeviceIcon,
  TagDeviceListIcon,
  TagListIcon,
  TagReceiptIcon,
  TagReceiptListIcon,
  TagWrenchIcon,
  TagWrenchListIcon,
  UserInviteIcon,
  WarehouseListIcon,
  WrenchListIcon,
} from "@/utils/iconsCustom";

export const Icon = IconBase as typeof IconBase & {
  // ! CRUD
  CREATE: typeof PlusIcon;
  DELETE: typeof TrashIcon;
  PAUSE: typeof PauseIcon;
  REMOVE: typeof XIcon;
  EDIT: typeof PencilSimpleIcon;
  EDIT_DISABLED: typeof PencilSimpleSlashIcon;
  FORMAT: typeof TextAaIcon;
  SAVE: typeof FloppyDiskIcon;
  CANCEL: typeof ProhibitIcon;
  PUBLISH: typeof EyeIcon;
  CLEAR: typeof XIcon;
  UNDO: typeof ArrowCounterClockwiseIcon;
  // ! ENTITIES
  WORKSPACE: typeof HouseIcon;
  WORKSPACES: typeof CityIcon;
  CUSTOMER_WORKSPACES: typeof BuildingOfficeIcon;
  WORKSPACE_DETAILS: typeof GearFineIcon;
  WORKSPACE_PROFILE: typeof IdentificationCardIcon;
  WORKSPACE_INVITATIONS: typeof UserInviteIcon;
  DEPLOYMENT: typeof WarehouseIcon;
  DEPLOYMENTS: typeof WarehouseListIcon;
  DEPLOYMENT_INVITATIONS: typeof EnvelopeSimpleIcon;
  PUBLIC_PORTAL: typeof LifebuoyIcon;
  MAP: typeof MapTrifoldIcon;
  DEVICE: typeof DeviceIcon;
  DEVICES: typeof DeviceListIcon;
  DEVICE_MODEL: typeof DeviceModelIcon;
  DEVICE_MODELS: typeof DeviceModelListIcon;
  MANUFACTURER: typeof FactoryIcon;
  MANUFACTURERS: typeof FactoryListIcon;
  PART_MANUFACTURER: typeof FactoryIcon;
  PART_CATEGORY: typeof ShapesIcon;
  PART_MODEL: typeof PartModelIcon;
  PART_REF: typeof IdentifierIcon;
  PART_ASSEMBLY: typeof PartAssemblyIcon;
  PART_DISASSEMBLY: typeof PartDisassemblyIcon;
  PART_DISASSEMBLY_TRASH: typeof TrashIcon;
  PART_CLEANING: typeof BroomIcon;
  PART_CALIBRATE: typeof CompassToolIcon;
  PART_REPAIR: typeof PipeWrenchIcon;
  PART_UPDATE: typeof ArrowsClockwiseIcon;
  PART_PRICE: typeof MoneyIcon;
  PART_LOCATION: typeof GpsFixIcon;
  PART: typeof NutIcon;
  PARTS: typeof NutListIcon;
  PART_COUNT: typeof CounterIcon;
  CASE: typeof ReceiptIcon;
  CASES: typeof ReceiptListIcon;
  TAG: typeof TagIcon;
  TAGS: typeof TagListIcon;
  TAG_ADD: typeof TagAddIcon;
  MAINTENANCE_TAG: typeof TagWrenchIcon;
  MAINTENANCE_TAGS: typeof TagWrenchListIcon;
  DEVICE_TAG: typeof TagDeviceIcon;
  DEVICE_TAGS: typeof TagDeviceListIcon;
  CASE_TAG: typeof TagReceiptIcon;
  CASE_TAGS: typeof TagReceiptListIcon;
  MAINTENANCE: typeof WrenchIcon;
  MAINTENANCES: typeof WrenchListIcon;
  MAINTENANCE_STRATEGY: typeof CalendarStarIcon;
  MAINTENANCE_STRATEGIES: typeof GanttChartIcon;
  STRATEGY_INTERVAL: typeof ClockCountdownIcon;
  STRATEGY_USAGE: typeof EngineIcon;
  STRATEGY_ANOMALY: typeof SealWarningIcon;
  DAILYTASK: typeof UserCircleCheckIcon;
  TASK: typeof SealCheckIcon;
  TASKS: typeof SealCheckIcon;
  CASE_TEMPLATE: typeof ReceiptIcon;
  CASE_TEMPLATES: typeof ReceiptListIcon;
  CHECKLIST_TEMPLATE: typeof ListChecksIcon;
  CHECKLIST_TEMPLATES: typeof ListChecksListIcon;
  USER: typeof UserIcon;
  USERS: typeof UsersIcon;
  USER_SETTINGS: typeof UserGearIcon;
  USER_MENU: typeof UserCircleIcon;
  DAILY_OVERVIEW: typeof UserFocusIcon;
  SERVICE_CONTRACT: typeof FileDashedIcon;
  SERVICE_JOB: typeof SuitcaseSimpleIcon;
  SERVICE_JOBS: typeof SuitcaseSimpleIcon;
  MISSION: typeof BriefcaseIcon;
  SETTINGS: typeof GearIcon;
  DEPLOYMENT_SETTINGS: typeof GearIcon;
  KNOWLEDGE_HUB: typeof BooksIcon;
  // ! Orders
  ORDER_PENDING: typeof SealQuestionIcon;
  ORDER_STARTED: typeof PlayCircleIcon;
  ORDER_FINISHED: typeof CheckIcon;
  ORDER_ABORTED: typeof ProhibitIcon;
  // ! Device Types
  AUTONOMOUS: typeof DeviceIcon;
  STATIONARY: typeof CraneTowerIcon;
  MANUAL: typeof BulldozerIcon;
  // ! Maintenances
  TIMER_START: typeof TimerIcon;
  PENDING: typeof ClockCountdownIcon;
  DUE: typeof AlarmIcon;
  TODAY: typeof ClockUserIcon;
  CLOCK: typeof ClockIcon;
  CALENDAR: typeof CalendarIcon;
  STARTED: typeof PlayCircleIcon;
  SKIPPED: typeof ArrowLineRightIcon;
  // ! Checklist Templates
  CT_PRIVATE: typeof HouseLineIcon;
  CT_PUBLIC: typeof GlobeHemisphereWestIcon;
  CT_SHARED: typeof ShareNetworkIcon;
  // ! Cases
  ARCHIVED: typeof ArchiveIcon;
  COMPLETED: typeof CheckCircleIcon;
  UNRESOLVED: typeof SealQuestionIcon;
  // ! Workspace Profile
  WP_PUBLIC: typeof EyeIcon;
  WP_PRIVATE: typeof EyeSlashIcon;
  // ! Device Data Triggers
  DEVICE_DATA_TRIGGER: typeof BellRingingIcon;
  DEVICE_DATA_TRIGGER_DERIVATIVE: typeof ChartLineIcon;
  DEVICE_DATA_TRIGGER_TWO_SIGMA: typeof LightningAIcon;
  // ! MISC
  COMMENT: typeof ChatCircleTextIcon;
  SEPERATOR: typeof LineVerticalIcon;
  QR_CODE: typeof QrCodeIcon;
  ZOOM_IN: typeof MagnifyingGlassPlusIcon;
  ZOOM_OUT: typeof MagnifyingGlassMinusIcon;
  STAR: typeof StarIcon;
  MICROPHONE: typeof MicrophoneIcon;
  MICROPHONE_DISABLED: typeof MicrophoneSlashIcon;
  SUPPORT: typeof HeadsetIcon;
  LEGAL: typeof ScalesIcon;
  ID: typeof IdentifierIcon;
  TABLE: typeof TableIcon;
  FINDER: typeof ColumnsIcon;
  GRID: typeof GridFourIcon;
  KANBAN: typeof KanbanIcon;
  TIMEZONE: typeof GlobeIcon;
  HISTORY: typeof ClockCounterClockwiseIcon;
  FUTURE: typeof ClockClockwiseIcon;
  MOVED_TO_DEPLOYMENT: typeof ArrowsOutCardinalIcon;
  TRIAL: typeof FlaskIcon;
  PARTY: typeof ConfettiIcon;
  STATUS: typeof ListChecksIcon;
  FILTER: typeof FunnelIcon;
  SORT_ASC: typeof SortAscendingIcon;
  SORT_DESC: typeof SortDescendingIcon;
  STORE: typeof StorefrontIcon;
  LOGOUT: typeof SignOutIcon;
  SEARCH: typeof MagnifyingGlassIcon;
  DOWNLOAD: typeof DownloadIcon;
  CALIBRATE: typeof CompassToolIcon;
  UPDATE: typeof ArrowsClockwiseIcon;
  UPLOAD: typeof UploadIcon;
  ROTATE_LEFT: typeof ArrowCounterClockwiseIcon;
  ROTATE_RIGHT: typeof ArrowClockwiseIcon;
  FULLSCREEN: typeof ArrowsOutIcon;
  FULLSCREEN_EXIT: typeof ArrowsInIcon;
  PRINT: typeof PrinterIcon;
  FILE: typeof FileIcon;
  FILES: typeof BookOpenTextIcon;
  FILE_PREVIEW: typeof FileMagnifyingGlassIcon;
  FILE_ADD: typeof PaperclipIcon;
  FILE_MISSING: typeof FileDashedIcon;
  FILE_ZIP: typeof FileZipIcon;
  FILE_CSV: typeof FileCsvIcon;
  FILE_IMAGE: typeof FileImageIcon;
  FILE_VIDEO: typeof FileVideoIcon;
  FILE_TEXT: typeof FileTextIcon;
  FILE_PDF: typeof FilePdfIcon;
  LINK: typeof LinkIcon;
  LINK_EXTERNAL: typeof ArrowSquareOutIcon;
  DRAGNDROP: typeof DotsNineIcon;
  CHART_BAR: typeof ChartBarIcon;
  GANTT: typeof ChartBarHorizontalIcon;
  CHART_LINE: typeof ChartLineIcon;
  INSIGHTS: typeof SparkleIcon;
  HELP: typeof QuestionIcon;
  WARNING: typeof WarningIcon;
  ERROR: typeof WarningOctagonIcon;
  INFO: typeof InfoIcon;
  GO_UP: typeof ArrowUpIcon;
  GO_DOWN: typeof ArrowDownIcon;
  GO_FORWARD: typeof ArrowRightIcon;
  GO_BACK: typeof ArrowLeftIcon;
  GO_FORWARD_CHEVRON: typeof CaretRightIcon;
  GO_BACK_CHEVRON: typeof CaretLeftIcon;
  GO_UP_CHEVRON: typeof CaretUpIcon;
  GO_DOWN_CHEVRON: typeof CaretDownIcon;
  GO_DOWN_RIGHT: typeof ArrowElbowDownRightIcon;
  RESET: typeof ArrowCounterClockwiseIcon;
  CHECK: typeof CheckIcon;
  EXPAND: typeof CaretRightIcon;
  COLLAPSE: typeof CaretDownIcon;
  CHECKBOX_OPEN: typeof SquareIcon;
  CHECKBOX_DONE: typeof CheckSquareIcon;
  MENU: typeof ListIcon;
  MENU_VERTICAL: typeof DotsThreeVerticalIcon;
  PLAY: typeof PlayIcon;
  STOP: typeof StopIcon;
  DOT: typeof CircleIcon;
  INVITE: typeof UserPlusIcon;
  EMAIL_SENT: typeof MailboxIcon;
  INSTRUCTIONS: typeof BookOpenTextIcon;
  MAGIC_ACTION: typeof MagicWandIcon;
  LIGHTMODE: typeof SunIcon;
  DARKMODE: typeof MoonIcon;
  AUTOMODE: typeof CloudMoonIcon;
  PREVIEW: typeof EyeIcon;
  AVAILABILITY: typeof TrendUpIcon;
  // ! ACADEMY
  ACADEMY: typeof GraduationCapIcon;
  ANOMALY: typeof SkullIcon;
  SOLUTION_PROPOSAL: typeof LightbulbIcon;
  CLEANING: typeof BroomIcon;
  REPAIRS: typeof PipeWrenchIcon;
  TROUBLESHOOTING: typeof LightningIcon;
  INSTALLATION: typeof WrenchIcon;
  SAFETY: typeof ShieldPlusIcon;
  WORKLOG: typeof ClipboardTextIcon;
  COPY: typeof CopyIcon;
  CONNECTION: typeof WifiHighIcon;
  CONNECTION_OFF: typeof WifiXIcon;
  // ! PARTS
  INVENTORY: typeof StackIcon;
  INVENTORY_INCOMING: typeof BoxArrowDownIcon;
  INVENTORY_PICKING: typeof TrayArrowDownIcon;
  INVENTORY_REQUESTED: typeof HandPalmIcon;
  INVENTORY_DATE: typeof CalendarIcon;
  INVENTORY_TAKE: typeof NotebookIcon;
  INVENTORY_TAKE_INCOMING: typeof PlusIcon;
  INVENTORY_ACTION_ADD: typeof PlusIcon;
  INVENTORY_ACTION_REMOVE: typeof MinusIcon;
  INVENTORY_ACTION_CHANGE: typeof ArrowsCounterClockwiseIcon;
  INVENTORY_ACTION_MOVE: typeof ArrowArcRightIcon;
  INVENTORY_ACTION_ISOLATE: typeof ArrowsSplitIcon;
  INVENTORY_PACKAGE: typeof PackageIcon;
  INVENTORY_ACTIVITIES: typeof SwapIcon;
  CONSTRAINTS: typeof BarricadeIcon;
  CONSTRAINT_WARN: typeof WarningIcon;
  CONSTRAINT_FAIL: typeof WarningOctagonIcon;
};

// ! CRUD
Icon.CREATE = PlusIcon;
Icon.DELETE = TrashIcon;
Icon.PAUSE = PauseIcon;
Icon.REMOVE = XIcon;
Icon.EDIT = PencilSimpleIcon;
Icon.EDIT_DISABLED = PencilSimpleSlashIcon;
Icon.FORMAT = TextAaIcon;
Icon.SAVE = FloppyDiskIcon;
Icon.CANCEL = ProhibitIcon;
Icon.PUBLISH = EyeIcon;
Icon.CLEAR = XIcon;
Icon.UNDO = ArrowCounterClockwiseIcon;
// ! ENTITIES
Icon.WORKSPACE = HouseIcon;
Icon.WORKSPACES = CityIcon;
Icon.CUSTOMER_WORKSPACES = BuildingOfficeIcon;
Icon.WORKSPACE_DETAILS = GearFineIcon;
Icon.WORKSPACE_PROFILE = IdentificationCardIcon;
Icon.WORKSPACE_INVITATIONS = UserInviteIcon;
Icon.DEPLOYMENT = WarehouseIcon;
Icon.DEPLOYMENTS = WarehouseListIcon;
Icon.DEPLOYMENT_INVITATIONS = EnvelopeSimpleIcon;
Icon.PUBLIC_PORTAL = LifebuoyIcon;
Icon.MAP = MapTrifoldIcon;
Icon.DEVICE = DeviceIcon;
Icon.DEVICES = DeviceListIcon;
Icon.DEVICE_MODEL = DeviceModelIcon;
Icon.DEVICE_MODELS = DeviceModelListIcon;
Icon.MANUFACTURER = FactoryIcon;
Icon.MANUFACTURERS = FactoryListIcon;
Icon.PART_MANUFACTURER = FactoryIcon;
Icon.PART_CATEGORY = ShapesIcon;
Icon.PART_MODEL = PartModelIcon;
Icon.PART_REF = IdentifierIcon;
Icon.PART_ASSEMBLY = PartAssemblyIcon;
Icon.PART_DISASSEMBLY = PartDisassemblyIcon;
Icon.PART_DISASSEMBLY_TRASH = TrashIcon;
Icon.PART_CLEANING = BroomIcon;
Icon.PART_CALIBRATE = CompassToolIcon;
Icon.PART_REPAIR = PipeWrenchIcon;
Icon.PART_UPDATE = ArrowsClockwiseIcon;
Icon.PART_PRICE = MoneyIcon;
Icon.PART_COUNT = CounterIcon;
Icon.PART_LOCATION = GpsFixIcon;
Icon.PART = NutIcon;
Icon.PARTS = NutListIcon;
Icon.CASE = ReceiptIcon;
Icon.CASES = ReceiptListIcon;
Icon.TAG = TagIcon;
Icon.TAGS = TagListIcon;
Icon.TAG_ADD = TagAddIcon;
Icon.MAINTENANCE_TAG = TagWrenchIcon;
Icon.MAINTENANCE_TAGS = TagWrenchListIcon;
Icon.DEVICE_TAG = TagDeviceIcon;
Icon.DEVICE_TAGS = TagDeviceListIcon;
Icon.CASE_TAG = TagReceiptIcon;
Icon.CASE_TAGS = TagReceiptListIcon;
Icon.MAINTENANCE = WrenchIcon;
Icon.MAINTENANCES = WrenchListIcon;
Icon.MAINTENANCE_STRATEGY = CalendarStarIcon;
Icon.MAINTENANCE_STRATEGIES = GanttChartIcon;
Icon.STRATEGY_INTERVAL = ClockCountdownIcon;
Icon.STRATEGY_USAGE = EngineIcon;
Icon.STRATEGY_ANOMALY = SealWarningIcon;
Icon.DAILYTASK = UserCircleCheckIcon;
Icon.TASK = SealCheckIcon;
Icon.TASKS = SealCheckIcon;
Icon.CASE_TEMPLATE = ReceiptIcon;
Icon.CASE_TEMPLATES = ReceiptListIcon;
Icon.CHECKLIST_TEMPLATE = ListChecksIcon;
Icon.CHECKLIST_TEMPLATES = ListChecksListIcon;
Icon.USER = UserIcon;
Icon.USERS = UsersIcon;
Icon.USER_SETTINGS = UserGearIcon;
Icon.USER_MENU = UserCircleIcon;
Icon.DAILY_OVERVIEW = UserFocusIcon;
Icon.SERVICE_CONTRACT = FileDashedIcon;
Icon.SERVICE_JOB = SuitcaseSimpleIcon;
Icon.SERVICE_JOBS = SuitcaseSimpleIcon;
Icon.MISSION = BriefcaseIcon;
Icon.SETTINGS = GearIcon;
Icon.DEPLOYMENT_SETTINGS = GearIcon;
Icon.KNOWLEDGE_HUB = BooksIcon;
// ! Orders
Icon.ORDER_PENDING = SealQuestionIcon;
Icon.ORDER_STARTED = PlayCircleIcon;
Icon.ORDER_FINISHED = CheckIcon;
Icon.ORDER_ABORTED = ProhibitIcon;
// ! Device Types
Icon.AUTONOMOUS = DeviceIcon;
Icon.STATIONARY = CraneTowerIcon;
Icon.MANUAL = BulldozerIcon;
// ! Maintenances
Icon.TIMER_START = TimerIcon;
Icon.PENDING = ClockCountdownIcon;
Icon.DUE = AlarmIcon;
Icon.TODAY = ClockUserIcon;
Icon.CLOCK = ClockIcon;
Icon.CALENDAR = CalendarIcon;
Icon.STARTED = PlayCircleIcon;
Icon.SKIPPED = ArrowLineRightIcon;
// ! Checklist Templates
Icon.CT_PRIVATE = HouseLineIcon;
Icon.CT_PUBLIC = GlobeHemisphereWestIcon;
Icon.CT_SHARED = ShareNetworkIcon;
// ! Cases
Icon.ARCHIVED = ArchiveIcon;
Icon.COMPLETED = CheckCircleIcon;
Icon.UNRESOLVED = SealQuestionIcon;
// ! Workspace Profile
Icon.WP_PUBLIC = EyeIcon;
Icon.WP_PRIVATE = EyeSlashIcon;
// ! Device Data Triggers
Icon.DEVICE_DATA_TRIGGER = BellRingingIcon;
Icon.DEVICE_DATA_TRIGGER_DERIVATIVE = ChartLineIcon;
Icon.DEVICE_DATA_TRIGGER_TWO_SIGMA = LightningAIcon;
// ! MISC
Icon.COMMENT = ChatCircleTextIcon;
Icon.SEPERATOR = LineVerticalIcon;
Icon.QR_CODE = QrCodeIcon;
Icon.ZOOM_IN = MagnifyingGlassPlusIcon;
Icon.ZOOM_OUT = MagnifyingGlassMinusIcon;
Icon.STAR = StarIcon;
Icon.MICROPHONE = MicrophoneIcon;
Icon.MICROPHONE_DISABLED = MicrophoneSlashIcon;
Icon.SUPPORT = HeadsetIcon;
Icon.LEGAL = ScalesIcon;
Icon.ID = IdentifierIcon;
Icon.TABLE = TableIcon;
Icon.FINDER = ColumnsIcon;
Icon.GRID = GridFourIcon;
Icon.KANBAN = KanbanIcon;
Icon.TIMEZONE = GlobeIcon;
Icon.HISTORY = ClockCounterClockwiseIcon;
Icon.FUTURE = ClockClockwiseIcon;
Icon.MOVED_TO_DEPLOYMENT = ArrowsOutCardinalIcon;
Icon.TRIAL = FlaskIcon;
Icon.PARTY = ConfettiIcon;
Icon.STATUS = ListChecksIcon;
Icon.FILTER = FunnelIcon;
Icon.SORT_ASC = SortAscendingIcon;
Icon.SORT_DESC = SortDescendingIcon;
Icon.STORE = StorefrontIcon;
Icon.LOGOUT = SignOutIcon;
Icon.SEARCH = MagnifyingGlassIcon;
Icon.DOWNLOAD = DownloadIcon;
Icon.CALIBRATE = CompassToolIcon;
Icon.UPDATE = ArrowsClockwiseIcon;
Icon.UPLOAD = UploadIcon;
Icon.ROTATE_LEFT = ArrowCounterClockwiseIcon;
Icon.ROTATE_RIGHT = ArrowClockwiseIcon;
Icon.FULLSCREEN = ArrowsOutIcon;
Icon.FULLSCREEN_EXIT = ArrowsInIcon;
Icon.PRINT = PrinterIcon;
Icon.FILE = FileIcon;
Icon.FILES = BookOpenTextIcon;
Icon.FILE_PREVIEW = FileMagnifyingGlassIcon;
Icon.FILE_ADD = PaperclipIcon;
Icon.FILE_MISSING = FileDashedIcon;
Icon.FILE_ZIP = FileZipIcon;
Icon.FILE_CSV = FileCsvIcon;
Icon.FILE_IMAGE = FileImageIcon;
Icon.FILE_VIDEO = FileVideoIcon;
Icon.FILE_TEXT = FileTextIcon;
Icon.FILE_PDF = FilePdfIcon;
Icon.LINK = LinkIcon;
Icon.LINK_EXTERNAL = ArrowSquareOutIcon;
Icon.DRAGNDROP = DotsNineIcon;
Icon.CHART_BAR = ChartBarIcon;
Icon.GANTT = ChartBarHorizontalIcon;
Icon.CHART_LINE = ChartLineIcon;
Icon.INSIGHTS = SparkleIcon;
Icon.HELP = QuestionIcon;
Icon.WARNING = WarningIcon;
Icon.ERROR = WarningOctagonIcon;
Icon.INFO = InfoIcon;
Icon.GO_UP = ArrowUpIcon;
Icon.GO_DOWN = ArrowDownIcon;
Icon.GO_FORWARD = ArrowRightIcon;
Icon.GO_BACK = ArrowLeftIcon;
Icon.GO_FORWARD_CHEVRON = CaretRightIcon;
Icon.GO_BACK_CHEVRON = CaretLeftIcon;
Icon.GO_UP_CHEVRON = CaretUpIcon;
Icon.GO_DOWN_CHEVRON = CaretDownIcon;
Icon.GO_DOWN_RIGHT = ArrowElbowDownRightIcon;
Icon.RESET = ArrowCounterClockwiseIcon;
Icon.CHECK = CheckIcon;
Icon.EXPAND = CaretRightIcon;
Icon.COLLAPSE = CaretDownIcon;
Icon.CHECKBOX_OPEN = SquareIcon;
Icon.CHECKBOX_DONE = CheckSquareIcon;
Icon.MENU = ListIcon;
Icon.MENU_VERTICAL = DotsThreeVerticalIcon;
Icon.PLAY = PlayIcon;
Icon.STOP = StopIcon;
Icon.DOT = CircleIcon;
Icon.INVITE = UserPlusIcon;
Icon.EMAIL_SENT = MailboxIcon;
Icon.INSTRUCTIONS = BookOpenTextIcon;
Icon.MAGIC_ACTION = MagicWandIcon;
Icon.LIGHTMODE = SunIcon;
Icon.DARKMODE = MoonIcon;
Icon.AUTOMODE = CloudMoonIcon;
Icon.PREVIEW = EyeIcon;
Icon.AVAILABILITY = TrendUpIcon;
// ! ACADEMY
Icon.ACADEMY = GraduationCapIcon;
Icon.ANOMALY = SkullIcon;
Icon.SOLUTION_PROPOSAL = LightbulbIcon;
Icon.CLEANING = BroomIcon;
Icon.REPAIRS = PipeWrenchIcon;
Icon.TROUBLESHOOTING = LightningIcon;
Icon.INSTALLATION = WrenchIcon;
Icon.SAFETY = ShieldPlusIcon;
Icon.WORKLOG = ClipboardTextIcon;
Icon.COPY = CopyIcon;
Icon.CONNECTION = WifiHighIcon;
Icon.CONNECTION_OFF = WifiXIcon;
// ! PARTS
Icon.INVENTORY = StackIcon;
Icon.INVENTORY_INCOMING = BoxArrowDownIcon;
Icon.INVENTORY_PICKING = TrayArrowDownIcon;
Icon.INVENTORY_REQUESTED = HandPalmIcon;
Icon.INVENTORY_DATE = CalendarIcon;
Icon.INVENTORY_TAKE = NotebookIcon;
Icon.INVENTORY_TAKE_INCOMING = PlusIcon;
Icon.INVENTORY_ACTION_ADD = PlusIcon;
Icon.INVENTORY_ACTION_REMOVE = MinusIcon;
Icon.INVENTORY_ACTION_CHANGE = ArrowsCounterClockwiseIcon;
Icon.INVENTORY_ACTION_MOVE = ArrowArcRightIcon;
Icon.INVENTORY_ACTION_ISOLATE = ArrowsSplitIcon;
Icon.INVENTORY_PACKAGE = PackageIcon;
Icon.INVENTORY_ACTIVITIES = SwapIcon;
Icon.CONSTRAINTS = BarricadeIcon;
Icon.CONSTRAINT_WARN = WarningIcon;
Icon.CONSTRAINT_FAIL = WarningOctagonIcon;
export default Icon;
